import React from 'react'
import { message, Table, TableColumnsType } from 'antd'
import Typography from '@mui/material/Typography'
import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material'
import dayjs from 'dayjs'
import {
  ONLY_DATE_FORMAT,
  ONLY_TIME_FORMAT,
} from '../../../../../../../constants/global'
import useAxios from '../../../../../../../hooks/useAxios'
import {
  ILeadAssignTo,
  ITrackingNotificationsGetCalendar,
} from '../../../../../../../types/trackingNotification'
import { IFilterMapped } from './LeadListNotificationFilter'
import { numberFormat } from '../../../../../../../utils'

interface ILeadListNotificationDetailModalProps {
  isOpen: boolean
  onClose: (visible: boolean) => void
  data?: ILeadAssignTo
  date?: IFilterMapped
}

export const LeadListNotificationDetailModal = (
  props: ILeadListNotificationDetailModalProps,
) => {
  const { isOpen, onClose, data, date } = props

  const reportList = useAxios<ITrackingNotificationsGetCalendar[]>({
    method: 'GET',
    url: '/lead/calendar',
    params: {
      assignToObjectId: data?.username,
      ...date,
      dateType: 'expiredAt',
    },
  })

  const columns: TableColumnsType<
    ITrackingNotificationsGetCalendar & { key: number }
  > = [
    {
      title: 'ลำดับ',
      dataIndex: 'numberRow',
      key: 'numberRow',
      width: 80,
      align: 'center' as const,
      render: (numberRow: number) => {
        return (
          <Typography
            variant="subtitle1"
            color="text.secondary"
            textAlign={'center'}
          >
            {numberRow}
          </Typography>
        )
      },
    },
    {
      title: 'วันที่',
      dataIndex: 'date',
      key: 'date',
      align: 'center' as const,
      render: (date: string) => {
        return (
          <Grid container flexDirection={'column'} textAlign={'center'}>
            <Grid item>
              <Typography variant="subtitle2" color="text.secondary">
                {dayjs(date).format(ONLY_DATE_FORMAT)}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="caption" color="text.secondary">
                {dayjs(date).format(ONLY_TIME_FORMAT)}
              </Typography>
            </Grid>
          </Grid>
        )
      },
    },
    {
      title: 'ทั้งหมด',
      dataIndex: 'count',
      key: 'count',
      align: 'center' as const,
      render: (count: number) => {
        return (
          <Typography
            variant="subtitle2"
            color="text.secondary"
            textAlign={'center'}
            minWidth={50}
          >
            {(count || 0).toLocaleString()}
          </Typography>
        )
      },
    },
    {
      title: 'ติดตามแล้ว',
      dataIndex: 'success',
      key: 'success',
      align: 'center' as const,
      render: (success: number) => {
        return (
          <Typography
            variant="subtitle2"
            color="text.secondary"
            textAlign={'center'}
            minWidth={50}
          >
            {(success || 0).toLocaleString()}
          </Typography>
        )
      },
    },
    {
      title: 'ยังไม่ติดตาม',
      dataIndex: 'pending',
      key: 'pending',
      align: 'center' as const,
      render: (pending: number) => {
        return (
          <Typography
            variant="subtitle2"
            color="text.secondary"
            textAlign={'center'}
            minWidth={50}
          >
            {(pending || 0).toLocaleString()}
          </Typography>
        )
      },
    },
  ]

  return (
    <Dialog
      PaperProps={{
        sx: {
          width: '100%',
          maxWidth: '1024px!important',
        },
      }}
      open={isOpen}
      onClose={() => onClose(false)}
      maxWidth="md"
    >
      <DialogTitle>รายการของ {data?.name}</DialogTitle>
      <DialogContent>
        <Table
          columns={columns}
          dataSource={reportList.data?.map(
            (report: ITrackingNotificationsGetCalendar, index: number) => {
              return {
                ...report,
                key: index,
                numberRow: index + 1,
              }
            },
          )}
          bordered
          pagination={false}
          summary={() => (
            <>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={2}>
                  <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    textAlign={'center'}
                  >
                    รวม
                  </Typography>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} colSpan={1}>
                  <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    textAlign={'center'}
                  >
                    {numberFormat(
                      reportList.data?.reduce(
                        (pre, cur) => pre + cur.count,
                        0,
                      ) || 0,
                    )}
                  </Typography>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3} colSpan={1}>
                  <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    textAlign={'center'}
                  >
                    {numberFormat(
                      reportList.data?.reduce(
                        (pre, cur) => pre + cur.success,
                        0,
                      ) || 0,
                    )}
                  </Typography>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={4} colSpan={1}>
                  <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    textAlign={'center'}
                  >
                    {numberFormat(
                      reportList.data?.reduce(
                        (pre, cur) => pre + cur.pending,
                        0,
                      ) || 0,
                    )}
                  </Typography>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </>
          )}
        />
      </DialogContent>
    </Dialog>
  )
}
